module.exports = __webpack_public_path__ + "static/media/Page22.26c2c15e.png";